import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { UserRole } from "@gryzonie/shared";
import { useAuthStore } from "../auth/auth.store";
import { api } from "../lib/api";

export function AppShell() {
  const user = useAuthStore((s) => s.user);
  const clear = useAuthStore((s) => s.clear);
  const navigate = useNavigate();

  const logout = async () => {
    try {
      await api("/auth/logout", { method: "POST" });
    } catch {
      /* ignore */
    } finally {
      clear();
      navigate("/login", { replace: true });
    }
  };

  return (
    <div className="flex h-full min-h-screen flex-col bg-base text-text">
      <header className="flex items-center justify-between border-b border-surface0 bg-crust px-6 py-3">
        <Link to="/dashboard" className="flex items-center gap-3">
          <img src="/GryzonieLogo.png" alt="Gryzonie" className="h-8 w-8" />
          <span className="text-lg font-semibold tracking-wide">Gryzonie</span>
        </Link>
        <nav className="flex items-center gap-4 text-sm">
          <NavLink
            to="/dashboard"
            className={({ isActive }) =>
              `rounded px-3 py-1.5 transition ${isActive ? "bg-surface0 text-primary" : "text-subtext1 hover:text-text"}`
            }
          >
            Pulpit
          </NavLink>
          {user?.role === UserRole.Admin && (
            <NavLink
              to="/admin"
              className={({ isActive }) =>
                `rounded px-3 py-1.5 transition ${isActive ? "bg-surface0 text-accent" : "text-subtext1 hover:text-text"}`
              }
            >
              Administracja
            </NavLink>
          )}
        </nav>
        <div className="flex items-center gap-3 text-sm text-subtext1">
          <span>
            {user?.displayName} <span className="text-overlay0">({user?.role})</span>
          </span>
          <button
            onClick={logout}
            className="rounded border border-surface1 bg-surface0 px-3 py-1.5 text-sm hover:bg-surface1"
          >
            Wyloguj
          </button>
        </div>
      </header>
      <main className="flex-1 overflow-auto p-6">
        <Outlet />
      </main>
    </div>
  );
}
